export default [
  {
    path: '/develop/:id?',
    name: 'develop',
    component: () => import('./views/IndexView.vue')
  },
]
